goog.provide("shadow.js.shim.module$dayjs$plugin$objectSupport");
goog.provide("module$shadow_js_shim_module$dayjs$plugin$objectSupport");
shadow.js.shim.module$dayjs$plugin$objectSupport = shadow.js.nativeProvides["dayjs/plugin/objectSupport"] = require("dayjs/plugin/objectSupport");
module$shadow_js_shim_module$dayjs$plugin$objectSupport.default = shadow.js.shim.module$dayjs$plugin$objectSupport;
